import { render, staticRenderFns } from "./DonutChartist.vue?vue&type=template&id=f15937ca&"
import script from "./DonutChartist.vue?vue&type=script&lang=js&"
export * from "./DonutChartist.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports